import React from 'react';
import { Column } from 'react-table';
import { FormattedMessage } from 'react-intl';
import { formatDate } from '../../../../common/helpers/dateHelper';
import { ICandidatePosition } from '../../../../common/models/candidate/ICandidatePosition';
import LinkButton from '../../../../components/LinkButton';
import Icon from '../../../../components/Icon';
import { IBindingCallback1 } from '../../../../common/models/callback';
import styles from './styles.module.scss';

export const getColumns = (onAttach: IBindingCallback1<string>): Column[] => [
  {
    Header: () => <FormattedMessage id="date" defaultMessage="Date" />,
    id: 'createdAt',
    accessor: item => formatDate((item as ICandidatePosition).createdAt),
    width: 115
  },
  {
    Header: () => <FormattedMessage id="position" defaultMessage="Position" />,
    id: 'positionName',
    Cell: ({ row: { original } }) => {
      const { positionName, id } = original as ICandidatePosition;
      return positionName || (
        <div className="d-flex align-items-center">
          <span className={styles.noPositionLabel}><FormattedMessage id="none" defaultMessage="None" /></span>
          <LinkButton
            textIntlId="contactProfile.candidate.attach"
            defaultMessage="Attach to position"
            icon={<Icon icon="position" />}
            onClick={e => {
              e.stopPropagation();
              onAttach(id);
            }}
          />
        </div>
      );
    },
    width: 250
  }
];
